import React from "react";
import {ApiResponse} from './axios';
import {FormattedMessage} from 'react-intl';

export const enum CommentStatus {
    "PENDING" = "pending",
    "APPROVED" = "approved",
    "REJECTED" = "rejected",
}

export interface Comment extends ApiResponse {
    userId: string;
    id: string;
    text: string;
    status: CommentStatus;
    video_content:any;
    like_count: number;
    dislike_count: number;
    user: any;
    created_at: any;
    modified_at: any;
    value: {},
    path: "string",
    op: "string",
    from: "string"
}

export interface CommentState {
    readonly loading: boolean
    readonly data: Comment[]
    readonly errors?: string
    readonly count: number
}

export const CommentStatusOptions = [{
    value: CommentStatus.PENDING,
    label: <FormattedMessage id="app.pending" defaultMessage={`Pending`}/>,
    color : 'blue'
}, {
    value: CommentStatus.APPROVED,
    label: <FormattedMessage id="app.approved" defaultMessage={`Approved`}/>,
    color : 'green'
}, {
    value: CommentStatus.REJECTED,
    label: <FormattedMessage id="app.rejected" defaultMessage={`Rejected`}/>,
    color : 'red'
}];

